<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('companies.group_company_data')}}</h3>
        <div class="lg:max-w-detail lg:mr-auto" v-if="(role === 7 || role === 8 || role === 3)">
          <div class="lg:mb-2" >
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
            <div class="flex justify-between">
              <el-form-item prop="clienteId" class="w-full">
                <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" filterable clearable :disabled="!isCreate" :loading="loadingClientes" />
              </el-form-item>
              <base-button v-if="!isCreate" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
            </div>
          </div>
        </div>
        <div class="lg:max-w-detail lg:mr-auto">

          <div v-if="isCreate" class="mb-4">
            <el-switch class="switch-text break-normal both-switch" 
              v-model="form.PersonaFisica" 
              :active-text="$t('tipos.persona.fisica')" 
              :inactive-text="$t('tipos.persona.juridica')"
              inactive-color="var(--primary-800)"
              >
            </el-switch>
          </div>

          <div v-if="form.PersonaFisica">
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
                <el-form-item prop="PersonaFisicaNombre">
                  <el-input
                    :disabled="isRoleUserOrConsulta"
                    clearable
                    class="w-full"
                    v-model="form.PersonaFisicaNombre"
                    maxlength='40'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('persons_data.firstsurname')}}</label>
                <el-form-item prop="PersonaFisicaPriApellido">
                  <el-input
                    :disabled="isRoleUserOrConsulta"
                    clearable
                    class="w-full"
                    v-model="form.PersonaFisicaPriApellido"
                    maxlength='40'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('persons_data.secondsurname')}}</label>
                <el-form-item prop="PersonaFisicaSegApellido">
                  <el-input
                    :disabled="isRoleUserOrConsulta"
                    clearable
                    class="w-full"
                    v-model="form.PersonaFisicaSegApellido"
                    maxlength='40'
                  />
                </el-form-item>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('companies.companyName')}}</label>
                <el-form-item prop="NombreCIF">
                  <el-input
                    :disabled="isRoleUserOrConsulta"
                    clearable
                    class="w-full"
                    v-model="form.NombreCIF"
                    maxlength='130'
                  />
                </el-form-item>
              </div>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('companies.cif')}}</label>
              <el-form-item prop="CIF">
                <el-input
                  :disabled="!isCreate || isRoleUserOrConsulta"
                  clearable
                  class="w-full"
                  v-model="form.CIF"
                  maxlength='50'
                />
              </el-form-item>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.telefono')}}</label>
              <el-form-item prop="Telefono" ref="Telefono">
                <el-input
                  :disabled="isRoleUserOrConsulta"
                  clearable
                  class="w-full"
                  v-model="form.Telefono"
                  maxlength='15'
                />
              </el-form-item>
            </div>
          </div>

          <div class="mb-4">
              <el-switch class="switch-text break-normal" :disabled="isRoleUserOrConsulta" v-model="form.Activo" :active-text="$t('app.active')"></el-switch>
          </div>
          <div class="lg:mb-2">
            <div class="mandatory" v-if="this.$route.params.id != -1">
              <base-ro-input-minimal :label="$t('app.created_at')" :data="form.FechaAlta"/>
            </div>
          </div>

        <div class="flex items-center mt-6 mb-4">
          <h3 class="dark:text-darkblue-200 font-bold">{{$t('address.header')}}</h3>
        </div>
        <div class="lg:mb-2">
          <div class="mandatory">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.location')}}</label>
            <el-form-item prop="Direccion" ref="Direccion">
              <el-input
                :disabled="isRoleUserOrConsulta"
                clearable
                class="w-full"
                v-model="form.Direccion"
                maxlength='80'
              />
            </el-form-item>
          </div>
        </div>
        <div class="lg:mb-2">
          <div class="mandatory">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.codigo_postal')}}</label>
            <el-form-item prop="CodigoPostal" ref="CodigoPostal">
              <el-input
                :disabled="isRoleUserOrConsulta"
                clearable
                class="w-full"
                v-model="form.CodigoPostal"
                maxlength='9'
              />
            </el-form-item>
          </div>
        </div>
        <div class="lg:mb-2">
          <div class="mandatory">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.poblacion')}}</label>
            <el-form-item prop="Poblacion" ref="Poblacion">
              <el-input
                :disabled="isRoleUserOrConsulta"
                clearable
                class="w-full"
                v-model="form.Poblacion"
                maxlength='50'
              />
            </el-form-item>
          </div>
        </div>
        <div class="lg:mb-2">
          <div class="mandatory">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.provincia')}}</label>
            <el-form-item prop="Provincia" ref="Provincia">
              <el-input v-if="!isSpain"
                :disabled="isRoleUserOrConsulta"
                clearable
                class="w-full"
                v-model="form.Provincia"
                maxlength='20'
              />
              <el-select v-else
                class="w-full" 
                v-model="form.Provincia" 
                filterable
                clearable 
                :placeholder="$t('app.select')"
                :disabled="isRoleUserOrConsulta">
                <el-option
                  v-for="opt in listProvincias"
                  :key="opt.id"
                  :label="opt.name"
                  :value="opt.name">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="lg:mb-2">
          <div class="mandatory">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.pais')}}</label>
            <el-form-item prop="Pais" ref="Pais">
              <base-el-select class="w-full" :options="listPaises" v-model="form.Pais" clearable filterable :disabled="isRoleUserOrConsulta" />
            </el-form-item>
          </div>
        </div>

        <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('avisos.header')}}</h3>
         <div class="mb-4">
          <div>
            <el-switch class="switch-text break-normal" :disabled="isRoleUserOrConsulta" v-model="form.EnviarAvisos" :active-text="$t('app.send_alerts')"></el-switch>
          </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_emitida')}}</label>
              <el-form-item prop="EmailAvisoNuevaEmitida" ref="EmailAvisoNuevaEmitida">
                <el-input
                  :disabled="isRoleUserOrConsulta"
                  clearable
                  class="w-full"
                  v-model="form.EmailAvisoNuevaEmitida"
                  :maxlength='maxLengthCorreos'
                />
              </el-form-item>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_recibida')}}</label>
              <el-form-item prop="EmailAvisoNuevaRecibida" ref="EmailAvisoNuevaRecibida">
                <el-input
                  :disabled="isRoleUserOrConsulta"
                  clearable
                  class="w-full"
                  v-model="form.EmailAvisoNuevaRecibida"
                  :maxlength='maxLengthCorreos'
                />
              </el-form-item>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_cambio_estado')}}</label>
              <el-form-item prop="EmailAvisoCambioEstado" ref="EmailAvisoCambioEstado">
                <el-input
                  :disabled="isRoleUserOrConsulta"
                  clearable
                  class="w-full"
                  v-model="form.EmailAvisoCambioEstado"
                  :maxlength='maxLengthCorreos'
                />
              </el-form-item>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tech')}}</label>
              <el-form-item prop="EmailTecnico" ref="EmailTecnico">
                <el-input
                  :disabled="isRoleUserOrConsulta"
                  clearable
                  class="w-full"
                  v-model="form.EmailTecnico"
                  :maxlength='maxLengthCorreos'
                />
              </el-form-item>
            </div>
          </div>
         
          <!-- <div v-if="!isCreate" class="rounded-md bg-secondary-50 p-1 dark:text-darkblue-400 dark:bg-darkblue-900 mt-8" >
            <div>
              <div v-if="form.CN" class="flex space-between items-end m-2">
                <div class="w-full">
                  <h2 class="px-2 w-full mb-2 lg:mb-0 font-bold">Certificado</h2>
                  <div  class="px-2 w-full mt-2">
                    <base-ro-input :label="$t('app.name')" :data="form.CN"/>
                  </div>
                </div>
                <base-button class="mb-1" mode="primary" :text="$t('app.detail')" @click.prevent.stop="goDetailCert" :loading="isGeneralLoading"/>
              </div>
              <div v-else class="flex space-between items-center m-2">
                <h2 class="w-full font-bold">{{ $t('companies.configuration.no_associated_cert') }}</h2>
                <base-button v-if="!isRoleUserOrConsulta" class="mb-1" mode="primary" :text="$t('app.link_entity')" @click.prevent.stop="togglelinkCertificateDialog" :loading="isGeneralLoading"/>
              </div>
            </div>
          </div> -->

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isCreate ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!isRoleUserOrConsulta" 
            mode="primary" 
            :text="isCompanyCreation ? $t('app.save_and_continue') : $t('app.save')" 
            icon="check" @click="submitForm('ruleForm')" 
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import { email as emailRegex } from '@/utils/regex'
import { i18n } from '@/i18n'

import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'

import { getCompany } from '@/services/companies/getCompany'
import { getCompanyTemplate } from '@/services/app/getCompanyTemplate'
import { updateCompany } from '@/services/companies/updateCompany'
import { createCompany } from '@/services/companies/createCompany'
import { linkUserCompanies } from '@/services/configurations/linkUserCompanies'
import { getClients } from '@/services/clients/getClients'
import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      extensionTooltipDatosDireccion: i18n.t('tooltip.companies.file_transformations_mandatory_data'),
      searchView: false,
      activeName: 'es',
      vuexnamespace: 'companies',
      loadingClientes: false,
      clientes: [],
      header: {
        title: i18n.t('companies.header_long'),
        icon: 'companies',
        breadcrumb: {},
        nav: [],
        url: 'companies'
      },
      maxLengthCorreos: 500,
      modeEmail: false,
      linkCertificateDialog: false,
      firmaDelegadaDialog: false,
      pdfVisualicer: null,
      form: {
        IdCIFEmpresa: 0,
        IdEmpresa: 0,
        CIF: '',
        CN: null,
        SerialNumber: null,
        TipoCertificado: null,
        NombreCIF: '',
        Activo: true,
        EmailTecnico: '',
        EmailAvisoNuevaEmitida: '',
        EmailAvisoNuevaRecibida: '',
        EmailAvisoCambioEstado: '',
        FechaAlta: '',
        FechaBaja: '',
        clienteId: '',
        EnviarAvisos: true,

        PersonaFisica: false,
        PersonaFisicaNombre: null,
        PersonaFisicaPriApellido: null,
        PersonaFisicaSegApellido: null,
        Telefono: null,
        Direccion: null,
        CodigoPostal: null,
        Poblacion: null,
        Provincia: null,
        Pais: 'ESP',
      },
      certificateForm: {
        CN: null,
        clienteId: null,
        SerialNumber: null,
        TipoCertificado: null,

        FaceMailInvoice: '',
        FaceRecoverMail: false,
        TuComunidadUsuario: '',
        TuComunidadPassword: '',
        FirmarFacturae: true,
        FirmarAdjuntos: false,
        FirmaDelegada: false,
      },
      responsableForm: {
        NombreApellidos: '',
        NIF: '',
        Municipio: '',
        ViaPublica: '',
        NumeroViaPublica: '',
      },
      tieneCertificado: false,
      certificate: null,
      validForm: false,
      validCertificateForm: false,
      creationIdCIFEmpresa: -1
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    isCompanyCreation: function () {
      return !!this.$store.getters['app/isInMode'](3)
    },
    isSpain: function () {
      return this.form.Pais.toUpperCase() === 'ESP'
    },
    isClientFilterActive () {
      return this.$store.getters['companies/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterVNav']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingClientes
    },
    hasCertificate: function () {
      return this.form.CN !== null && this.form.CN !== ''
    },
    idTipoServicioCliente: function () {
      return this.$store.getters['auth/idTipoServicioCliente']
    },
    rules () {
      return {
        clienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        NombreCIF: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        CIF: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        PersonaFisicaNombre: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        PersonaFisicaPriApellido: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        PersonaFisicaSegApellido: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Telefono: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Direccion: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        CodigoPostal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
          {
            required: true,
            message: i18n.t('validation.length_number') + i18n.tc('app.n_character', 5),
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!this.isSpain) {
                callback()
              } else {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              }
            }
          },
        ],
        Poblacion: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Provincia: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Pais: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          },
        ],
        EmailTecnico: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoNuevaEmitida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoNuevaRecibida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoCambioEstado: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    },
    rulesCertificate () {
      return {}
    },
    rulesPersonaResponsable () {
      return {
        NombreApellidos: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        NIF: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        Municipio: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        ViaPublica: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        NumeroViaPublica: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
      }
    },
    listProvincias: function () {
      return this.$store.getters['config/PROVINCIAS']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },  
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    if (this.isCreate) this.$store.dispatch('app/enterMode', 3) 
    const companyId = this.$route.params.id
    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: i18n.t('companies.header') })
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
      this.loadingClientes = false
    }

    if (companyId !== -1 && companyId !== '-1') {
      await this.downloadCompanyData(companyId)
      breadcrumbs.push({ path: '', name: this.form.NombreCIF })
      this.$store.commit('app/setheaderBreadCrumb', this.form.NombreCIF)
    } else {
      breadcrumbs.push({ path: '', name: i18n.t('companies.new_company') })
      if (this.role !== 3 && this.role !== 8 && this.role !== 7) {
        const template = await getCompanyTemplate()
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        }
        template.respuesta.CodigoPais = 'ESP'
        this.setCompany(template.respuesta)
      }
    }

    if (this.isCreate && this.actualFilterNav && this.isClientFilterActive) {
      this.form.clienteId = this.actualFilterNav.idCliente 
    }

    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    watchFormHandler: function ({ certificate, send_alerts }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    togglelinkCertificateDialog () {
      this.linkCertificateDialog = !this.linkCertificateDialog
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else if (value.length > this.maxLengthCorreos) {
        callback(new Error(i18n.t('validation.email_length', { n_chars: i18n.tc('app.n_character', this.maxLengthCorreos) })))
      } else {
        callback()
      }
    },
    submitForm: async function (formName) {
      setTimeout(() => {
        try {
          this.$store.commit('setIsLoading', true)
          this.$refs[formName].validate(async valid => {
            if (valid) {
              const params = {
                CIF: this.form.CIF,
                RazonSocial: this.form.NombreCIF,
                // EmailAvisoNueva: this.form.EmailAvisoNueva,
                EmailTecnico: this.form.EmailTecnico,
                EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
                EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
                EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
                EnviarAvisos: this.form.EnviarAvisos,
                FechaAlta: this.form.FechaAlta ? this.form.FechaAlta : null,
                Activo: this.form.Activo,
                PersonaFisica: this.form.PersonaFisica,
                PersonaFisicaNombre: this.form.PersonaFisicaNombre,
                PersonaFisicaPrimerApellido: this.form.PersonaFisicaPriApellido,
                PersonaFisicaSegundoApellido: this.form.PersonaFisicaSegApellido,
                Telefono: this.form.Telefono,
                Direccion: this.form.Direccion,
                CodigoPostal: this.form.CodigoPostal,
                Poblacion: this.form.Poblacion,
                Provincia: this.form.Provincia,
                CodigoPais: this.form.Pais,
              }
              let response = null
              if (this.$route.params.id === -1 || this.$route.params.id === '-1') {
                params.idCliente = this.form.clienteId
                response = await createCompany(params)
                if (response && response.blnError === false) {
                  this.creationIdCIFEmpresa = response.IdCIFEmpresa
                  
                  if (this.role !== 3 && this.role !== 8 && this.role !== 7) {
                    await this.$store.dispatch('auth/me', false)
                    const user = this.$store.getters['auth/user']
                    response = await linkUserCompanies({ idCifs: [response.IdCIFEmpresa], idUsuario: user.idUsuario })
                  } else {
                    response = { blnError: false }
                  }
                  if (response && response.blnError === false) {
                    if (this.role !== 3 && this.role !== 8 && this.role !== 7) {
                      const template = await getCompanyTemplate()
                      if (template.blnError) {
                        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
                      } else {
                        this.resetForm()
                        this.$store.commit('setIsLoading', false)
                        template.respuesta.CodigoPais = 'ESP'
                        this.setCompany(template.respuesta)
                        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
                        this.goBack(this.creationIdCIFEmpresa)
                      }
                    } else {
                      this.resetForm()
                      this.$store.commit('setIsLoading', false)
                      this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
                      this.goBack(this.creationIdCIFEmpresa)
                    }
                  } else {
                    this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
                  }
                } else {
                  this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
                }
              } else {
                response = await updateCompany(params, this.$route.params.id)
                if (response && response.blnError === false) {
                  this.$store.commit('setIsLoading', false)
                  this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
                  this.header.breadcrumb[1].name = this.form.NombreCIF
                  this.$store.commit('app/setheaderBreadCrumb', this.form.NombreCIF)
                } else {
                  this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
                }
              }
            } else {
              this.doFeedback(i18n.t('feedback.error.process_data_error'))
              return false
            }
          })
        } catch (error) {
          this.doFeedback(error)
        } finally {
          this.$store.commit('setIsLoading', false)
        }
      }, 100)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function (idCIFEmpresa = -1) {
      if (typeof idCIFEmpresa === 'number' && idCIFEmpresa !== -1 && this.isCompanyCreation) {
        this.goCreateConfigAvisos(idCIFEmpresa)
      } else {
        this.$router.push({ name: 'companies' })
      }
    },
    goDetailCert: function () {
      const idEmpresa = this.form.clienteId
      const serial = this.form.SerialNumber
      const tipo = this.form.TipoCertificado
      this.$router.push({ name: 'certificates/detail', params: { idEmpresa, serial, tipo } })
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    goCreateConfigAvisos (idCIFEmpresa) {
      setTransitionAllowed(3, true)
      this.$router.push({ name: 'companies/config', params: { id: idCIFEmpresa } })
    },
    downloadCompanyData: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: companyId }
        const company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', company))
        } else {
          this.setCompany(company.CIFEmpresa, company.TipoServicio)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCompany: function (company, tipoServicio = null) {
      if (company) {
        this.form.NombreCIF = company.RazonSocial ? company.RazonSocial : null
        this.form.CIF = company.CIF ? company.CIF : null
        this.form.EmailTecnico = company.EmailTecnico ? company.EmailTecnico : null
        this.form.EmailAvisoNuevaEmitida = company.EmailAvisoNuevaEmitida ? company.EmailAvisoNuevaEmitida : null
        this.form.EmailAvisoNuevaRecibida = company.EmailAvisoNuevaRecibida ? company.EmailAvisoNuevaRecibida : null
        this.form.EmailAvisoCambioEstado = company.EmailAvisoCambioEstado ? company.EmailAvisoCambioEstado : null
        this.form.FechaAlta = company.FechaAlta ? i18n.d(company.FechaAlta, 'numeric_datetime', { date: '-', datetime: ' ' }) : null
        this.form.FechaBaja = company.FechaBaja ? i18n.d(company.FechaBaja, 'numeric_datetime', { date: '-', datetime: ' ' }) : null
        this.form.EnviarAvisos = company.EnviarAvisos
        this.form.Activo = company.Activo
        this.form.clienteId = company.idCliente ? company.idCliente : null
        this.form.CN = company.CN ? company.CN : null
        this.form.SerialNumber = company.SerialNumber ? company.SerialNumber : null
        this.form.TipoCertificado = company.TipoCertificado ? company.TipoCertificado : null
        this.form.idTipoServicio = tipoServicio?.IdTipoServicio ? tipoServicio?.IdTipoServicio : null

        this.form.PersonaFisica = company.PersonaFisica ? company.PersonaFisica : null
        this.form.PersonaFisicaNombre = company.PersonaFisicaNombre ? company.PersonaFisicaNombre : null
        this.form.PersonaFisicaPriApellido = company.PersonaFisicaPrimerApellido ? company.PersonaFisicaPrimerApellido : null
        this.form.PersonaFisicaSegApellido = company.PersonaFisicaSegundoApellido ? company.PersonaFisicaSegundoApellido : null
        this.form.Telefono = company.Telefono ? company.Telefono : null

        this.form.Direccion = company.Direccion ? company.Direccion : null
        this.form.CodigoPostal = company.CodigoPostal ? company.CodigoPostal : null
        this.form.Poblacion = company.Poblacion ? company.Poblacion : null
        this.form.Provincia = company.Provincia ? company.Provincia : null
        this.form.Pais = company.CodigoPais ? company.CodigoPais : null
      }
    },
    resetCompany: function () {
      this.form.NombreCIF = null
      this.form.CIF = null
      this.form.EmailTecnico = null
      this.form.EmailAvisoNuevaEmitida = null
      this.form.EmailAvisoNuevaRecibida = null
      this.form.EmailAvisoCambioEstado = null
      this.form.FechaAlta = null
      this.form.FechaBaja = null
      this.form.EnviarAvisos = true
      this.form.Activo = true
      this.form.clienteId = null
      this.form.CN = null
      this.form.SerialNumber = null
      this.form.TipoCertificado = null
      this.form.idTipoServicio = null
      
      this.form.PersonaFisica = false
      this.form.PersonaFisicaNombre = null
      this.form.PersonaFisicaPriApellido = null
      this.form.PersonaFisicaSegApellido = null
      this.form.Telefono = null

      this.form.Direccion = null
      this.form.CodigoPostal = null
      this.form.Poblacion = null
      this.form.Provincia = null
      this.form.Pais = 'ESP'
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-height: 100%;
}

</style>

<style lang="sass" scoped>
</style>
